import axiosInstance from "../axiosInstance";

export const expensesApi = {
  get: (path, params, cancelToken) =>
    axiosInstance
      .get(`/Expenses${path}`, {
        params,
        cancelToken: cancelToken?.token,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/Expenses${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  put: (path, params, headers, cancelToken) =>
    axiosInstance
      .put(`/Expenses${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  delete: (path, params, cancelToken) =>
    axiosInstance
      .delete(`/Expenses${path}`, {
        params,
        cancelToken: cancelToken?.token,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const getExpensesTotals = async () =>
  expensesApi.get("/GetExpensesTotals");

export const getExpenseApplicationDetails = async (applicationId) =>
  expensesApi.get("/GetApplicationDetails", { applicationId });

export const getTransHeaderExpense = async (transHeaderId) =>
  expensesApi.get("/GetTransHeaderExpense", { transHeaderId });

export const getTransHeaderExpenseHeader = async (transHeaderId) =>
  expensesApi.get("/GetTransHeaderExpenseHeader", { transHeaderId });

export const getTransHeaderExpensePayments = async (transHeaderId) =>
  expensesApi.get("/GetTransHeaderExpensePayments", { transHeaderId });

export const getTransHeaderExpensePayment = async (paymentTransHeaderId) =>
  expensesApi.get("/GetTransHeaderExpensePayment", { paymentTransHeaderId });

export const getTransHeaderExpenseTotals = async (transHeaderId) =>
  expensesApi.get("/GetTransHeaderExpenseTotals", { transHeaderId });

export const getTransHeaderExpenseRows = async (transHeaderId) =>
  expensesApi.get("/GetTransHeaderExpenseRows", { transHeaderId });

export const getExpenseTypes = async (transTypeId) =>
  expensesApi.get(
    "/GetExpenseTypes",
    transTypeId === undefined || transTypeId === null || transTypeId === ""
      ? undefined
      : { transTypeId }
  );

export const getExpenseAppartments = async (applicationId, transTypeId) =>
  expensesApi.get("/GetExpenseAppartments", { applicationId, transTypeId });

export const getExpenseChildren = async ({
  applicationId,
  transTypeId,
  search,
}) =>
  expensesApi.get("/GetExpenseChildren", {
    applicationId,
    transTypeId,
    search,
  });

export const getExpenseEmployeeByAmka = async ({
  applicationId,
  search,
  transTypeId,
}) =>
  expensesApi.get("/GetExpenseEmployeeByAmka", {
    applicationId,
    search,
    transTypeId,
  });

export const getExpenseEmployeeRegistryInfo = async ({
  applicationId,
  afm,
  amka,
  transTypeId,
}) =>
  expensesApi.get("/GetExpenseEmployeeRegistryInfo", {
    applicationId,
    afm,
    amka,
    transTypeId,
  });

export const getExpenseEmployeeJobTypes = async () =>
  expensesApi.get("/GetExpenseEmployeeJobTypes");

export const createExpenseEmployee = async (params) =>
  expensesApi.post("/CreateExpenseEmployee", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const updateExpenseEmployee = async (params) =>
  expensesApi.put("/UpdateExpenseEmployee", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const deleteExpenseEmployee = async (employeeId) =>
  expensesApi.delete("/DeleteExpenseEmployee", { employeeId });

export const getTransTypes = async (isPayment) =>
  expensesApi.get(
    "/GetTransTypes",
    isPayment === undefined ? undefined : { isPayment }
  );

export const getPaymentTypes = async () => expensesApi.get("/GetPaymentTypes");

export const createTransHeaderExpense = async (params) =>
  expensesApi.post("/CreateTransHeaderExpense", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const updateTransHeaderExpense = async (params) =>
  expensesApi.put("/UpdateTransHeaderExpense", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const submitTransHeaderExpense = async (params) =>
  expensesApi.put("/SubmitTransHeaderExpense", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const cancelTransHeaderExpense = async (params) =>
  expensesApi.put("/CancelTransHeaderExpense", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const getTransHeaderExpenseAmendmentStatus = async (transHeaderId) =>
  expensesApi.get("/GetTransHeaderExpenseAmendmentStatus", { transHeaderId });

export const amendTransHeaderExpense = async (params) =>
  expensesApi.put("/AmendTransHeaderExpense", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const saveTransHeaderExpenseReview = async (params) =>
  expensesApi.put("/SaveTransHeaderExpenseReview", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const reviewTransHeaderExpense = async (params) =>
  expensesApi.put("/ReviewTransHeaderExpense", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const addTransHeaderExpenseBundle = async (params) =>
  expensesApi.post("/AddTransHeaderExpenseBundle", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const createTransHeaderExpenseRow = async (params) =>
  expensesApi.post("/CreateTransHeaderExpenseRow", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const updateTransHeaderExpenseRow = async (params) =>
  expensesApi.put("/UpdateTransHeaderExpenseRow", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const createTransHeaderExpensePayment = async (params) =>
  expensesApi.post("/CreateTransHeaderExpensePayment", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const updateTransHeaderExpensePayment = async (params) =>
  expensesApi.put("/UpdateTransHeaderExpensePayment", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const canChangeTransHeaderExpenseType = async (transHeaderId) =>
  expensesApi.get("/CanChangeTransHeaderExpenseType", { transHeaderId });

export const deleteTransHeaderExpense = async (transHeaderId, force = false) =>
  expensesApi.delete("/DeleteTransHeaderExpense", { transHeaderId, force });

export const deleteTransHeaderExpenseRow = async (transExpenseId) =>
  expensesApi.delete("/DeleteTransHeaderExpenseRow", { transExpenseId });

export const deleteTransHeaderExpensePayment = async (paymentTransHeaderId) =>
  expensesApi.delete("/DeleteTransHeaderExpensePayment", {
    paymentTransHeaderId,
  });

export const getSupplierByAfm = async (afm) =>
  expensesApi.get("/GetSupplierByAfm", { afm });

export const searchSuppliers = async ({
  search,
  pageNumber = 1,
  pageSize = 10,
}) => expensesApi.get("/SearchSuppliers", { search, pageNumber, pageSize });

export const createSupplier = async (params) =>
  expensesApi.post("/CreateSupplier", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const updateSupplier = async (params) =>
  expensesApi.put("/UpdateSupplier", JSON.stringify(params), {
    "Content-Type": "application/json",
  });
